angular.module('avant.customer_applications.controllers', ['ngCookies', 'track-angular']);
require('./ApplicationMixinCtrl.coffee');
require('./CustomerApplicationsAdditionalInformationCtrl.coffee');
require('./CustomerApplicationsBankAccountCtrl.coffee');
require('./CustomerApplicationsCompletePurchaseCtrl.coffee');
require('./CustomerApplicationsDeclinedCtrl.coffee');
require('./CustomerApplicationsHomeCtrl.coffee');
require('./CustomerApplicationsLoadingCtrl.coffee');
require('./CustomerApplicationsLoanOfferCtrl.coffee');
require('./CustomerApplicationsMixinCtrl.coffee');
require('./CustomerApplicationsPaymentDetailsCtrl.coffee');
require('./CustomerApplicationsPersonalCtrl.coffee');
require('./CustomerApplicationsPersonalContinuedCtrl.coffee');
require('./CustomerApplicationsRatesTermsCtrl.coffee');
require('./CustomerApplicationsRedirectCtrl.coffee');
require('./CustomerApplicationsReturnToMerchantCtrl.coffee');
require('./CustomerApplicationsCongratulationsCtrl.coffee');
require('./CustomerApplicationsScheduledMaintenanceCtrl.coffee');
require('./CustomerApplicationsServiceFailureCtrl.coffee');
require('./CustomerApplicationsVehicleCtrl.coffee');
require('./DemoCtrl.coffee');
require('./SectionMixinCtrl.coffee');
require('./NeuroIdMixinCtrl.coffee');
